import { Box } from '@mui/material';
import { EntitySectionGroup } from './EntitySectionGroup';
import { IEntitySectionGroupsProps } from './EntitySection.types';

export function EntitySectionGroups({ thing, closeDrawer }: IEntitySectionGroupsProps) {
  return (
    <Box sx={{ mt: 2 }}>
      {thing.steps.map((step) => (
        <EntitySectionGroup key={step.id} step={step} work={thing} closeDrawer={closeDrawer} />
      ))}
    </Box>
  );
}
